var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDisableVijiliseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none",
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#C9C9CC",
    fillRule: "evenodd",
    d: "M15.146 6.15 8.996 0 0 8.995l8.996 8.996.963-.963-8.032-8.033 7.069-7.069L13.22 6.15l-2.342 2.342.963.963 3.305-3.305Zm-2.823.022L8.996 2.845l-6.15 6.15 7.573 7.573.963-.963-6.61-6.61 4.224-4.224 1.4 1.401-.918.92.962.963 1.883-1.883Zm-.482 7.048L6.654 8.033l-.963.962 6.15 6.151 6.15-6.15-.963-.963-5.187 5.187Zm0-2.846L8.077 6.61l-.964.963 4.728 4.727 4.728-4.727-.963-.963-3.765 3.764Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisableVijiliseIcon);
export default __webpack_public_path__ + "static/media/disable-vijilise-icon.6685d62a49d1bd94a3278e1524c5cad6.svg";
export { ForwardRef as ReactComponent };